import React from "react";
import Tooltip from "@mui/material/Tooltip";

const FabricIcons = ({
	fabricData,
	selectedShade,
	seriesData,
	ultrasonicRequired,
	haveSet,
	reflectiveBacking,
	soundAbsorption,
}) => {
	const renderTooltipIcon = (condition, title, src, alt) => {
		if (!condition) return null;
		return (
			<Tooltip title={title}>
				<img src={src} width={60} className="p-2" alt={alt} />
			</Tooltip>
		);
	};

	const baseIconsData = [
		{
			condition:
				fabricData[0].greenRating && fabricData[0].greenRating !== "NULL",
			title: "Eco-friendly",
			src: "https://dealerportal.mysunglow.com/images/icons/eco-friendly-icon.png",
			alt: "Eco-friendly",
		},
		{
			condition:
				fabricData[0].antimicrobialRating &&
				fabricData[0].antimicrobialRating !== "NULL",
			title: "Anti-microbial",
			src: "https://dealerportal.mysunglow.com/images/icons/antimicrobial-icon.png",
			alt: "Anti-microbial",
		},
		{
			condition:
				fabricData[0].fireRating && fabricData[0].fireRating !== "NULL",
			title: "Fire-resistant",
			src: "https://dealerportal.mysunglow.com/images/icons/fire-resist-icon.png",
			alt: "Fire-resistant",
		},
		{
			condition:
				fabricData[0].graphicAllowed && fabricData[0].graphicAllowed !== "NULL",
			title: "Graphic Shade Compatible",
			src: "https://dealerportal.mysunglow.com/images/icons/graphic-shades-icon.png",
			alt: "Graphic Shade Compatible",
		},
	];

	const rollerIconsData = [
		{
			title:
				"Compatible with Roller Shades, Vision Shades, Panel Track, Atlas Bottom Up Shades, Fixed Shades, Nimbus Skylight Shades, Dual Shades",
			src: "https://dealerportal.mysunglow.com/images/icons/roller-shade-icon.png",
			alt: "Roller Shade Compatible",
		},
	];

	const additionalIconsData = [
		{
			condition: fabricData[0].railroad == 1,
			title: "Rail Road Option",
			src: "https://dealerportal.mysunglow.com/images/icons/rail_road-icon.png",
			alt: "Rail Road Option",
		},
		{
			condition: haveSet.includes(seriesData.toLowerCase()),
			title: "Part of a Set",
			src: "https://dealerportal.mysunglow.com/images/icons/matching-set-icon.png",
			alt: "Part of a Set",
		},
		{
			condition: reflectiveBacking.includes(seriesData.toLowerCase()),
			title: "Reflective",
			src: "https://dealerportal.mysunglow.com/images/icons/reflective_icon.png",
			alt: "Reflective/Metalized Backing",
		},
		{
			condition: soundAbsorption.includes(seriesData.toLowerCase()),
			title: "Sound Absorption",
			src: "https://dealerportal.mysunglow.com/images/icons/sound-absorption-icon.png",
			alt: "Sound Absorption",
		},
	];

	return (
		<div className="flex flex-wrap justify-start mt-3">
			{baseIconsData.map((icon, index) =>
				renderTooltipIcon(icon.condition, icon.title, icon.src, icon.alt)
			)}

			{selectedShade === "roller" && (
				<>
					{rollerIconsData.map((icon, index) =>
						renderTooltipIcon(true, icon.title, icon.src, icon.alt)
					)}
				</>
			)}

			{selectedShade === "interlude" &&
				renderTooltipIcon(
					true,
					"Compatible with Interlude Shades, Dual Shades, Fixed Shades",
					"https://dealerportal.mysunglow.com/images/icons/interlude-icon.png",
					"Interlude Shade Compatible"
				)}

			{selectedShade === "illusion" &&
				renderTooltipIcon(
					true,
					"Compatible with Illusions, Dual Shades, Fixed Shades",
					"https://dealerportal.mysunglow.com/images/icons/illusions-icon.png",
					"Illusions  Compatible"
				)}

			{selectedShade === "Simply Cellular" &&
				renderTooltipIcon(
					true,
					"Simply Cellular Shade Compatible",
					"https://dealerportal.mysunglow.com/images/icons/cellular.png",
					"Simply Cellular Shade Compatible"
				)}

			{additionalIconsData.map((icon, index) =>
				renderTooltipIcon(icon.condition, icon.title, icon.src, icon.alt)
			)}

			{selectedShade === "Simply Cellular"
				? null
				: ultrasonicRequired.includes(seriesData.toLowerCase())
				? renderTooltipIcon(
						true,
						"Ultrasonic",
						"https://dealerportal.mysunglow.com/images/icons/ultrasonic-icon.png",
						"Ultrasonic"
				  )
				: renderTooltipIcon(
						true,
						"Cold/Crush Cut",
						"https://dealerportal.mysunglow.com/images/icons/cold-crush-icon.png",
						"Cold/Crush Cut"
				  )}
		</div>
	);
};

export default FabricIcons;
